(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var mainImage = document.getElementById("main-image");
    var thumbnails = document.querySelectorAll(".thumbnail");

    thumbnails.forEach(function(thumbnail) {
      thumbnail.addEventListener("click", function() {
        thumbnails.forEach(function(t) {
          t.classList.remove("selected-thumbnail");
        });
        this.classList.add("selected-thumbnail");
        mainImage.src = this.getAttribute("data-src");
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
